import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isMostRequested", "isActive", "slotNumber", "headerTitle", "type", "onClick"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { Badge } from '@restworld/ui-ds-base';
import IconButton from '../icon-button';
import { SkeletonTextLoading } from '../skeleton-loading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var CardContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__CardContainer",
  componentId: "sc-fs5hun-0"
})(["", " ", " ", " ", " ", ";"], {
  "minHeight": "14rem",
  "width": "100%",
  "cursor": "pointer",
  "padding": "1.25rem"
}, {
  "borderRadius": "1rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "--tw-shadow": "0px 4px 16px 0px rgba(0,0,26,0.15)",
  "--tw-shadow-colored": "0px 4px 16px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
}, {
  "display": "inline-flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "1.25rem"
}, {
  "borderWidth": "2px"
}, function (_ref) {
  var isActive = _ref.isActive;
  return isActive && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))"
  };
});

var ContentContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__ContentContainer",
  componentId: "sc-fs5hun-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "2rem",
  "alignSelf": "stretch"
});

var HeaderTop = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__HeaderTop",
  componentId: "sc-fs5hun-2"
})({
  "display": "inline-flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "alignSelf": "stretch"
});

var HeaderLeft = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__HeaderLeft",
  componentId: "sc-fs5hun-3"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.75rem",
  "borderRadius": "0.5rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
});

var IconContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__IconContainer",
  componentId: "sc-fs5hun-4"
})(["", " ", ";", ""], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
}, {
  "height": "1rem",
  "width": "1rem",
  "borderRadius": "384px",
  "borderWidth": "2px"
}, function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))"
  } : {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))"
  };
});

var InnerIcon = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__InnerIcon",
  componentId: "sc-fs5hun-5"
})(["", " ", ""], {
  "height": "0.5rem",
  "width": "0.5rem",
  "borderRadius": "9999px"
}, function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(102 51 187 / var(--tw-bg-opacity))"
  } : {
    "backgroundColor": "transparent"
  };
});

var HeaderText = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__HeaderText",
  componentId: "sc-fs5hun-6"
})({
  "fontSize": "1rem",
  "lineHeight": "1",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var HeaderRight = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__HeaderRight",
  componentId: "sc-fs5hun-7"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-end",
  "gap": "0.125rem"
});

var Price = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__Price",
  componentId: "sc-fs5hun-8"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var Tax = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__Tax",
  componentId: "sc-fs5hun-9"
})({
  "fontSize": "0.875rem",
  "lineHeight": "21px",
  "fontWeight": "300",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var CardBody = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__CardBody",
  componentId: "sc-fs5hun-10"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "1rem",
  "alignSelf": "stretch"
});

var BodyText = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__BodyText",
  componentId: "sc-fs5hun-11"
})({
  "alignSelf": "stretch",
  "fontSize": "0.875rem",
  "lineHeight": "21px",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});

var Footer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__Footer",
  componentId: "sc-fs5hun-12"
})(["", " ", ""], {
  "display": "inline-flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "1.25rem",
  "alignSelf": "stretch",
  "borderRadius": "0.5rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
}, function (_ref4) {
  var isActive = _ref4.isActive;
  return isActive ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
  };
});

var FooterButton = /*#__PURE__*/_styled(IconButton).withConfig({
  displayName: "slot-purchase-card__FooterButton",
  componentId: "sc-fs5hun-13"
})({
  "display": "flex",
  "width": "2.5rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.5rem",
  "padding": "0.5rem"
});

var FooterText = /*#__PURE__*/_styled.div.withConfig({
  displayName: "slot-purchase-card__FooterText",
  componentId: "sc-fs5hun-14"
})(["", " ", " ", " ", ""], {
  "width": "3.125rem"
}, {
  "textAlign": "center"
}, {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500"
}, function (_ref5) {
  var isActive = _ref5.isActive;
  return isActive ? {
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(117 117 131 / var(--tw-text-opacity))"
  };
});

var HeaderLeftComponent = function HeaderLeftComponent(_ref6) {
  var isActive = _ref6.isActive,
      headerTitle = _ref6.headerTitle,
      type = _ref6.type;
  return /*#__PURE__*/_jsxs(HeaderLeft, {
    children: [type !== 'subscription' && /*#__PURE__*/_jsx(IconContainer, {
      isActive: isActive,
      children: /*#__PURE__*/_jsx(InnerIcon, {
        isActive: isActive
      })
    }), /*#__PURE__*/_jsx(HeaderText, {
      children: headerTitle
    })]
  });
};

var HeaderRightComponent = function HeaderRightComponent(_ref7) {
  var bundlePrice = _ref7.bundlePrice,
      slotPrice = _ref7.slotPrice,
      type = _ref7.type,
      discountPrice = _ref7.discountPrice,
      loading = _ref7.loading;
  return /*#__PURE__*/_jsx(HeaderRight, {
    children: loading ? /*#__PURE__*/_jsx(SkeletonTextLoading, {
      width: "xSmall"
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [discountPrice && /*#__PURE__*/_jsxs(_StyledH, {
        children: [discountPrice, "\u20AC"]
      }), /*#__PURE__*/_jsx(Price, {
        children: type !== 'custom' ? "".concat(bundlePrice, "\u20AC").concat(type === 'subscription' ? "/mese" : '') : "".concat(slotPrice, "\u20AC")
      }), /*#__PURE__*/_jsx(Tax, {
        children: "+ iva"
      })]
    })
  });
};

var CardBodyComponent = function CardBodyComponent(_ref8) {
  var slotPurchaseDescriptions = _ref8.slotPurchaseDescriptions;
  return /*#__PURE__*/_jsx(CardBody, {
    children: slotPurchaseDescriptions === null || slotPurchaseDescriptions === void 0 ? void 0 : slotPurchaseDescriptions.map(function (text, index) {
      return /*#__PURE__*/_jsx(BodyText, {
        children: text
      }, index);
    })
  });
};

var FooterComponent = function FooterComponent(_ref9) {
  var isActive = _ref9.isActive,
      onSlotAdd = _ref9.onSlotAdd,
      onSlotMinus = _ref9.onSlotMinus,
      slotNumber = _ref9.slotNumber;
  return /*#__PURE__*/_jsxs(Footer, {
    isActive: isActive,
    children: [/*#__PURE__*/_jsx(FooterButton, {
      size: "md",
      ariaLabel: "minus",
      Icon: MinusIcon,
      variant: isActive ? 'restworld' : 'neutral',
      disabled: !isActive || slotNumber === 1,
      onClick: onSlotMinus
    }), /*#__PURE__*/_jsxs(FooterText, {
      isActive: isActive,
      children: [slotNumber, " slot"]
    }), /*#__PURE__*/_jsx(FooterButton, {
      size: "md",
      ariaLabel: "plus",
      Icon: PlusIcon,
      variant: isActive ? 'restworld' : 'neutral',
      disabled: !isActive || slotNumber === 10,
      onClick: onSlotAdd
    })]
  });
};

export function SlotPurchaseCard(_ref10) {
  var isMostRequested = _ref10.isMostRequested,
      isActive = _ref10.isActive,
      slotNumber = _ref10.slotNumber,
      headerTitle = _ref10.headerTitle,
      type = _ref10.type,
      onClick = _ref10.onClick,
      rest = _objectWithoutProperties(_ref10, _excluded);

  var _useTranslation = useTranslation('product-description-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(CardContainer, {
    onClick: onClick,
    isActive: isActive,
    children: [/*#__PURE__*/_jsxs(HeaderTop, {
      children: [/*#__PURE__*/_jsx(HeaderLeftComponent, {
        type: type,
        isActive: isActive,
        headerTitle: headerTitle
      }), /*#__PURE__*/_jsx(HeaderRightComponent, _objectSpread({
        type: type
      }, rest))]
    }), /*#__PURE__*/_jsxs(ContentContainer, {
      children: [/*#__PURE__*/_jsx(CardBodyComponent, _objectSpread({}, rest)), (type === 'custom' || type === 'subscription') && /*#__PURE__*/_jsx(FooterComponent, _objectSpread({
        slotNumber: slotNumber,
        isActive: isActive
      }, rest)), isMostRequested && /*#__PURE__*/_jsx(Badge, {
        variant: "success",
        children: /*#__PURE__*/_jsx("h5", {
          className: "text-green-700 text-sm font-medium",
          children: t('most_requested')
        })
      })]
    })]
  });
}
export default SlotPurchaseCard;

var _StyledH = /*#__PURE__*/_styled("h5").withConfig({
  displayName: "slot-purchase-card___StyledH",
  componentId: "sc-fs5hun-15"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))",
  "textDecorationLine": "line-through"
});